import { Container } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { graphql, useStaticQuery } from 'gatsby'
import { ReactNode } from 'react'
import { News } from './News'
import styles from './NewsList.module.scss'

export type ZoneNewsListProps = {
  __typename: 'StrapiGQL_ComponentZonesNews'
  id: string
  title: ReactNode
}

export const QUERY_NEWS = graphql`
  query NewsQuery {
    strapiGQL {
      newsArticles(publicationState: LIVE, sort: "date:desc") {
        ...StrapiGQL_NewsArticlesFragment
        newsImage {
          __typename
          id
          url
          ext
          resolved {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                formats: WEBP
                webpOptions: { quality: 100 }
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
      }
    }
  }
`

export default function ZoneNewsList(props: ZoneNewsListProps) {
  const {
    strapiGQL: { newsArticles },
  } = useStaticQuery(QUERY_NEWS)
  return (
    <Whitespace type="md">
      <Container>
        <News
          itemClassName={styles.itemWrapper}
          list={newsArticles.filter(a => !a.isUnlisted)}
        />
      </Container>
    </Whitespace>
  )
}
